import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";

const categories = [
  {
    to: "/brand",
    icon: "ri-book-2-line",
    title: "品牌介绍",
    description: "品牌历史、产品线、发展历程与企业文化，一文了解品牌全貌。",
    count: "6 篇专题",
  },
  {
    to: "/news",
    icon: "ri-newspaper-line",
    title: "相关资讯",
    description: "公司新闻、行业动态、媒体报道与活动公告实时更新。",
    count: "8 条资讯",
  },
  {
    to: "/resources",
    icon: "ri-folder-download-line",
    title: "资源查询",
    description: "白皮书、研究报告、工具与培训资料，支持组合条件检索。",
    count: "8 项资源",
  },
];

export default function CategoryCards() {
  return (
    <section className="px-4 md:px-8 py-14 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="快速入口"
          title="按主题浏览内容"
          description="三个核心板块覆盖品牌认知、资讯获取与资源检索，点击即可进入对应分类页。"
        />
        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {categories.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300 hover:bg-primary-50/60"
            >
              <span className="flex items-center justify-center w-12 h-12 rounded-md bg-primary-500 text-background-50">
                <i className={`${item.icon} text-2xl`} />
              </span>
              <div className="flex flex-col gap-2">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">
                  {item.title}
                </h3>
                <p className="text-sm leading-relaxed text-foreground-600">
                  {item.description}
                </p>
              </div>
              <div className="mt-auto flex items-center justify-between pt-2">
                <span className="text-xs font-medium text-secondary-600">{item.count}</span>
                <span className="flex items-center gap-1 text-sm font-medium text-accent-600">
                  进入
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}